// extracted by mini-css-extract-plugin
module.exports = {"main-component":"mediumPriority_main-component__36Kk_"};